import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { ReportConfig, ReportDownloadTypes } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersComponent, ReportFiltersModule } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  OrthodonticTreatmentReportTableComponentModule,
  OrthodonticTreatmentReportTableComponent
} from './components/orthodontic-treatment-report-table/orthodontic-treatment-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { AuthService } from '@src/app/features/authentication/services/auth.service';
import { PermissionEnum } from '@core/permissions/permission.enum';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-orthodontic-treatments-report',
  templateUrl: './orthodontic-treatment-report.component.html',
  imports: [
    GenericWidePageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    OrthodonticTreatmentReportTableComponent,
    TranslateModule,
    AsyncPipe
  ]
})
export class OrthodonticTreatmentReportComponent extends BaseComponent implements OnInit {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);
  private authService = inject(AuthService);

  @ViewChild(ReportFiltersComponent) reportFiltersComponent: ReportFiltersComponent;
  readonly reportConfig: ReportConfig = {
    type: 'ORTHODONTIC_TREATMENTS',
    downloadOptions: {
      [ReportDownloadTypes.EXCEL]: true,
      [ReportDownloadTypes.EXCEL_ADMIN]: true,
      [ReportDownloadTypes.EXCEL_ADMIN_ID]: true
    },
    filters: {
      recordDate: true,
      gender: true,
      age: true,
      includePhotos: true,
      practitioners: true,
      geography: true,
      organizationsTree: true,
      orthoTypes: true,
      orthoStatuses: true,
      orthoQaGrading: this.authService.checkUserPermission(PermissionEnum.VIEW_REPORT_QA_FILTER)
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList('ORTHODONTIC_TREATMENTS', this.reportService.model, pagination);
  }

  ngOnInit(): void {
    this.subSink.sink = this.reportService.initialized$.subscribe(value => {
      if (value && this.reportService.reportFiltersFormGroup.status !== 'VALID') {
        this.reportService.showFilters();
      }
    });
  }
}

@NgModule({
  imports: [
    ReportFiltersModule,
    TranslateModule,
    CommonModule,
    OrthodonticTreatmentReportTableComponentModule,
    GeneralCommonsModule,
    OrthodonticTreatmentReportComponent
  ],
  exports: [OrthodonticTreatmentReportComponent]
})
export class OrthodonticTreatmentReportComponentModule {}
